import { useState } from "react";
import dayjs from "dayjs";
import { Calendar } from "../../components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "../../components/ui/popover";
import { CalendarDays } from "lucide-react";

export function DateField({ value, onChange, placeholder = "Select date", className = "", testId, disabledBefore, disabledAfter, noFuture, disabled: isDisabled = false, disabledHint }) {
  const [open, setOpen] = useState(false);
  const selected = value ? dayjs(value).toDate() : undefined;
  const maxDate = disabledAfter || (noFuture ? dayjs().format("YYYY-MM-DD") : null);
  const disabled = [
    ...(disabledBefore ? [{ before: dayjs(disabledBefore).toDate() }] : []),
    ...(maxDate ? [{ after: dayjs(maxDate).toDate() }] : []),
  ];
  return (
    <div className={className}>
    <Popover open={open && !isDisabled} onOpenChange={(o) => !isDisabled && setOpen(o)}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testId} disabled={isDisabled} title={isDisabled ? disabledHint : undefined} aria-disabled={isDisabled}
          className={`flex h-12 w-full items-center justify-between rounded-xl border px-4 text-left text-[15px] transition-colors focus:outline-none ${
            isDisabled ? "cursor-not-allowed border-[#EFEBE0] bg-[#F5F2EB] opacity-70" : "border-[#E5DFD3] bg-white hover:border-[#8D6E63] focus:ring-2 focus:ring-[#8D6E63]"
          } ${value ? "text-[#3E2723] font-medium" : "text-[#84675B]"}`}>
          <span className="truncate">{value ? dayjs(value).format("MMM D, YYYY") : placeholder}</span>
          <CalendarDays size={19} className={`shrink-0 ml-2 ${isDisabled ? "text-[#84675B]" : "text-[#7B6157]"}`} />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-2 rounded-2xl border-[#EFEBE0] bg-white shadow-[0_16px_48px_-12px_rgba(62,39,35,0.3)]" align="start">
        <Calendar
          mode="single"
          selected={selected}
          defaultMonth={selected}
          disabled={disabled.length ? disabled : undefined}
          onSelect={(d) => { if (d) onChange(dayjs(d).format("YYYY-MM-DD")); setOpen(false); }}
          captionLayout="dropdown-buttons"
          fromYear={new Date().getFullYear() - 110}
          toYear={new Date().getFullYear() + 6}
          classNames={{
            caption: "flex justify-center pt-1 relative items-center",
            caption_label: "hidden",
            vhidden: "hidden",
            caption_dropdowns: "flex items-center gap-2",
            dropdown: "rounded-lg border border-[#E5DFD3] bg-white px-2 py-1.5 text-sm font-semibold text-[#3E2723] cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#8D6E63]",
            dropdown_month: "flex", dropdown_year: "flex",
            head_cell: "text-[#7B6157] w-10 font-semibold text-xs uppercase",
            cell: "p-0.5 text-center",
            day: "h-10 w-10 p-0 rounded-full text-[15px] text-[#3E2723] hover:bg-[#F5F2EB] transition-colors aria-selected:opacity-100",
            day_disabled: "opacity-30 pointer-events-none line-through",
            day_selected: "bg-[#4E342E] text-white hover:bg-[#4E342E] hover:text-white focus:bg-[#4E342E] focus:text-white font-bold",
            day_today: "bg-[#EDE4D7] text-[#3E2723] font-bold",
            day_outside: "text-[#C9BEB0]",
          }}
        />
      </PopoverContent>
    </Popover>
    </div>
  );
}
